import VideoTestimonials from 'common/video_testimonials';

if (document.querySelector('.js-learn-page')) {
  new VideoTestimonials();
}
